import React from 'react';
import ReactExport from 'react-export-excel';

const ExcelCbsOverzicht = props => {
	const {dbUser, data, columns, periode} = props;

	const ExcelFile = ReactExport.ExcelFile;
	const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
	const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

	const prefix = dbUser.aanbieders.find(row => {
		return row.id === dbUser.aanbieder;
	});

	return (
		<ExcelFile
			filename={prefix.label + ' ' + prefix.naam + ' - CBS overzicht ' + periode}
			element={
				<button className='button download'>
					<strong>Excel</strong>
				</button>
			}>
			<ExcelSheet data={data} name='CBS'>
				{columns.map(column => (
					<ExcelColumn key={column.label} label={column.label} value={column.value} />
				))}
			</ExcelSheet>
		</ExcelFile>
	);
};

export default ExcelCbsOverzicht;
